module.exports = __webpack_public_path__ + "img/business-man_resized.7830c9a6.png";